app.controller("EditSubjectController", [
    "$scope", "$http", "$uibModalInstance", "Subject", "StaticData", "subjectId", "InfoModal", "GradeTemplate", "ConfirmModal",
    function ($scope, $http, $uibModalInstance, Subject, StaticData, subjectId, InfoModal, GradeTemplate, ConfirmModal) {
        $scope.name = "";
        $scope.nameEN = "";
        $scope.author = "";
        $scope.code = "";
        $scope.dep_id = "";
        var oldTemplate;

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = levels;
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        Subject.fetchOne(subjectId).then(function (data) {
            var subject = data.subject;
            $scope.name = subject.name;
            $scope.nameEN = subject.nameEN;
            $scope.author = subject.author;
            $scope.code = subject.code;
            $scope.level = subject.level;
            $scope.credits = subject.credits;
            $scope.template = subject.gradeTemplate;
            $scope.oldTemplate = oldTemplate = subject.gradeTemplate;
            $scope.dependencies = subject.prerequisites || [];
            $scope.syllabusFile = subject.syllabusFile;
        });

        $scope.$watch('newDependency', function (val) {
            if (val && val._id) {
                $scope.dependencies.push(val);
                $scope.newDependency = null;
            }
        }, true);

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query}).then(function (data) {
                return data.docs.filter(function (subj) {
                    var elementIndex = _.findIndex($scope.dependencies, function (dependency) {
                        return dependency._id === subj._id;
                    });

                    if (subjectId === subj._id) {
                        return false;
                    }

                    return elementIndex === -1;
                })
            });
        };

        GradeTemplate.list().then(function (list) {
            $scope.templates = list;
        });

        $scope.dependencies = [];
        $scope.delete_dependency = function (id) {
            var elementIndex = _.findIndex($scope.dependencies, function (dep) {
                return id === dep._id;
            });

            $scope.dependencies.splice(elementIndex, 1);
        };

        $scope.update = function () {

            if(!$scope.template) {
                InfoModal.show({message: "გთხოვთ მიუთითოთ შაბლონი", title: "შეცდომა"});
                return;
            }

            if(!$scope.level) {
                InfoModal.show({message: "გთხოვთ მიუთითოთ საფეხური", title: "შეცდომა"});
                return;
            }

            if (!$scope.editSubjectForm.$valid) {
                InfoModal.show({message: "შეავსეთ ყველა ველი სწორად", title: "შეცდომა"});
                return;
            }

            if ($scope.template === "") {
                $scope.template = null;
            }

            var prerequisitesList = [];
            $scope.dependencies.forEach(function (el) {
                prerequisitesList.push(el._id);
            });
            var subjectData = {
                _id: subjectId,
                name: $scope.name,
                nameEN: $scope.nameEN,
                code: $scope.code,
                author: $scope.author,
                credits: $scope.credits,
                level: $scope.level,
                prerequisites: prerequisitesList,
                gradeTemplate: $scope.template,
                syllabusFile: $scope.syllabusFile
            };

            function updateSubject() {
                Subject.update(subjectData).then(function (resp) {
                    $uibModalInstance.close();
                });
            }

            if (oldTemplate !== $scope.template) {
                ConfirmModal.show({
                    message: "შაბლონის ცვლილება გამოიწვევს მიმდინარე ქულების წაშლას. გავაგრძელოთ?",
                    title: "გაფრთხილება"
                }).result.then(function () {
                    updateSubject();
                });
            } else {
                updateSubject();
            }

        };

        $scope.uploadSyllabus = function (files) {
            $scope.file = files[0];
            if ($scope.file) {
                $scope.fileName = $scope.file.name;
                var fd = new FormData();
                fd.append('file', $scope.file);
                $http.post('/file/syllabus/upload', fd, {
                    headers: {'Content-Type': undefined}
                }).then(function (response) {
                    //console.log(response)
                    $scope.syllabusFile = response.data.Location;
                })
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
